import { gql } from '@apollo/client';

export const DOCUMENTS = gql`
	query Documents($userId: UUID, $workplaceId: UUID, $types: [DocumentType]) {
		documents(
			userId: $userId
			workplaceId: $workplaceId
			types: $types
			pagination: { take: 9999, order: { key: "created_at", how: DESC } }
		) {
			data {
				id
				type
				createdAt
				title {
					id
					type
					extra
					createdAt
				}
				content {
					id
					type
					extra
					createdAt
				}
				createdBy {
					profile {
						fullName
					}
				}
				items {
					id
					type
					extra
					createdAt
				}
				file {
					avResult
					avResultText
				}
			}
		}
	}
`;
